<template>
    <el-dialog
        width='600px'
        :title= "translate('transaction_approve_modal.title')"
        :visible.sync='show'
        :close-on-click-modal='false'
        :before-close='close'
    >
        <el-form class="content">
            <div class="product" v-for="(product, index) in products" :key='index'>
                <span class="product-name"> {{ translate(`table.product_codes.${product.codigoProduto.toLowerCase()}`) }}: </span>
                <span> {{ formatNumberToLocale(product.volumeTon) }} </span>
            </div>

            <p style="margin-top: 20px;">{{ translate('transaction_approve_modal.approve_text') }}</p>

            <div class="decision-row" style="margin-top: 16px;">
                <el-radio-group class="decision-group" v-model="selectedDecision">
                    <el-radio label="REPROVADA" class="decision-item">{{ translate('transaction_approve_modal.disapprove_button') }}</el-radio>
                    <el-radio label="APROVADA" class="decision-item">{{ translate('transaction_approve_modal.approve_button') }}</el-radio>
                    <el-radio :label="decisaoAprovacaoTotal" class="decision-item" v-if="transaction.codigoTipoTransacao === 'TRANSFERENCIA_TITULARIDADE'">{{ translate('transaction_approve_modal.approve_total_button') }}</el-radio>
                </el-radio-group>
            </div>

            <div style="margin-top: 12px;">
                <template
                    v-if="(selectedDecision === 'APROVADA' || selectedDecision === decisaoAprovacaoTotal) && transaction.transformacao === false"
                >
                    <el-form-item>
                        <span>
                            {{ verificarAprovacaoTotal(selectedDecision)
                                ? translate('transaction_approve_modal.balance_label_total_approved')
                                : translate('transaction_approve_modal.balance_label') }}
                        </span>
                        <el-input
                            type="number"
                            v-model.number="balance"
                            :disabled="verificarAprovacaoTotal(selectedDecision)"
                        />
                    </el-form-item>
                </template>

                <template class="decision-inputs" v-else-if="selectedDecision === 'REPROVADA'">
                    <el-form-item>
                        <span>{{ translate('transaction_approve_modal.reason_label') }}</span>
                        <el-input
                            type="textarea"
                            :rows="4"
                            v-model="reason"
                            :placeholder="translate('transaction_approve_modal.reason_placeholder')"
                        />
                    </el-form-item>
                </template>
            </div>

            <div class="actions" style="margin-top: 20px; text-align: right;">
                <el-button @click="close">{{ translate('transaction_approve_modal.cancel_button') }}</el-button>
                <el-button type="primary" style="margin-left: 10px;" :disabled="!selectedDecision" @click="confirmDecision">
                    {{ translate('transaction_approve_modal.confirm_button') }}
                </el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import TransferenciaTitularidadeService from '@/services/TransferenciaTitularidadeService';
import RastreabilidadeTransacaoArmazemService from '@/services/RastreabilidadeTransacaoArmazemService';
import formatters from '@/utils/formatters';

const DECISAO_APROVACAO_TOTAL = 'APROVACAO_TOTAL';

export default {
    name: 'warehouseTransactionApproveModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        transaction: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedDecision: null,
            balance: null,
            reason: '',
            products: [],
            decisaoAprovacaoTotal: DECISAO_APROVACAO_TOTAL
        };
    },
    computed: {
        totalEsperadoTon() {
            if (!this.products || this.products.length === 0) {
                return null;
            }
            return this.products.reduce((soma, item) => {
                const volume = item.volumeTon;
                if (volume === null || volume === undefined || Number.isNaN(Number(volume))) {
                    return soma;
                }
                return soma + Number(volume);
            }, 0);
        }
    },
    watch: {
        selectedDecision(novo) {
            if (this.verificarAprovacaoTotal(novo)) {
                this.preencherSaldoComTotalEsperado();
            } else if (novo === 'APROVADA') {
                this.balance = null;
            } else if (novo === 'REPROVADA') {
                this.balance = null;
            }
        },
        products: {
            handler() {
                if (this.verificarAprovacaoTotal(this.selectedDecision)) {
                    this.preencherSaldoComTotalEsperado();
                }
            },
            deep: true
        }
    },
    mounted() {
        this.listProducts();
    },
    methods: {
        verificarAprovacaoTotal(opacaoSelecionada) {
            return (opacaoSelecionada === DECISAO_APROVACAO_TOTAL) || (opacaoSelecionada === 'APROVADA' && this.transaction.codigoTipoTransacao === 'EMPRESTIMO');
        },
        preencherSaldoComTotalEsperado() {
            if (this.totalEsperadoTon === null) {
                return;
            }
            this.balance = this.totalEsperadoTon;
        },
        listProducts() {
            RastreabilidadeTransacaoArmazemService.getProductList(this.transaction.id)
            .then(({ data }) => {
                this.products = data;

            }).catch(() => {
                this.$notify.error({ message: this.translate('transaction_approve_modal.error.erro_produto') });
            });
        },
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        statusParaEnvio() {
            if (this.selectedDecision === DECISAO_APROVACAO_TOTAL) {
                return 'APROVADA';
            }
            return this.selectedDecision;
        },
        confirmDecision() {
            if (!this.selectedDecision) return;

            const aprovacaoComSaldo = (this.selectedDecision === 'APROVADA' || this.selectedDecision === DECISAO_APROVACAO_TOTAL) &&
                this.transaction.transformacao === false;

            if (aprovacaoComSaldo) {
                if (this.balance === null || Number.isNaN(this.balance)) {
                    this.$notify.error({ message: this.translate('transaction_approve_modal.validation_balance_required') });
                    return;
                }
            }

            TransferenciaTitularidadeService.aprovarReprovar({
                idTransacao: this.transaction.id,
                codigoStatus: this.statusParaEnvio(),
                saldoAprovadoTon: this.balance,
                motivoReprovacao: this.reason
            }).then(() => {
                this.$notify.success({ message: this.translate('transaction_approve_modal.success_message') });
                this.close();
                this.$emit('confirm');
            }).catch((error) => {
                if (error.response && error.response.data && error.response.data.includes('error_message')) {
                    this.$notify.error({ message: this.translate('transaction_approve_modal.error.' + error.response.data), duration: 6000 });
                    return;
                }
                this.$notify.error({ message: this.translate('transaction_approve_modal.error_message') });
            });
        },
        close() {
            this.selectedDecision = null;
            this.balance = null;
            this.reason = '';
            this.$emit('close');
        },
        formatNumberToLocale(value) {
            return formatters.minFormatNumber(value, 2, this.$i18n.locale) + ' t';
        }
    }
};
</script>

<style scoped lang="scss">
    .content {
        .decision-group {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            .decision-item {
                margin-right: 20px !important;
            }
        }
        .product {
            font-size: 15px;
            .product-name {
                font-weight: bold;
                color: #00413c;
            }
        }
    }
</style>
